import { createValidation } from '../../utils/validation';
import supplierRatingConfig from './supplierRatingConfig';

// Create validation factory for SupplierRating entity
const createSupplierRatingValidation = () => {
  return createValidation(supplierRatingConfig.fields);
};

// Export both the factory and a default instance
export const validateSupplierRatingData = createSupplierRatingValidation();
export const createSupplierRatingValidationSchema = createSupplierRatingValidation;
export default createSupplierRatingValidation;
